import React from 'react'

const MaleIcon = () => (
	<svg
		className="male"
		stroke="currentColor"
		fill="none"
		strokeWidth="2"
		viewBox="0 0 24 24"
		strokeLinecap="round"
		strokeLinejoin="round"
		height="1em"
		width="1em"
		xmlns="http://www.w3.org/2000/svg"
	>
		<title>Male</title>
		<circle cx="10" cy="14" r="5"></circle>
		<path d="M14 10l6-6"></path>
		<path d="M16 4h4v4"></path>
	</svg>
)

export default MaleIcon
